/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DistributionChannel from './DistributionChannel';

/**
 * The CampaignControllerDtoCreateAppRequest model module.
 * @module model/CampaignControllerDtoCreateAppRequest
 * @version 1.0
 */
class CampaignControllerDtoCreateAppRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoCreateAppRequest</code>.
     * @alias module:model/CampaignControllerDtoCreateAppRequest
     */
    constructor() { 
        
        CampaignControllerDtoCreateAppRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoCreateAppRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoCreateAppRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoCreateAppRequest} The populated <code>CampaignControllerDtoCreateAppRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoCreateAppRequest();

            if (data.hasOwnProperty('category')) {
                obj['category'] = ApiClient.convertToType(data['category'], 'Number');
            }
            if (data.hasOwnProperty('packageName')) {
                obj['packageName'] = ApiClient.convertToType(data['packageName'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('developer')) {
                obj['developer'] = ApiClient.convertToType(data['developer'], 'String');
            }
            if (data.hasOwnProperty('profileImage')) {
                obj['profileImage'] = ApiClient.convertToType(data['profileImage'], 'String');
            }
            if (data.hasOwnProperty('appUrl')) {
                obj['appUrl'] = ApiClient.convertToType(data['appUrl'], 'String');
            }
            if (data.hasOwnProperty('distributionChannel')) {
                obj['distributionChannel'] = DistributionChannel.constructFromObject(data['distributionChannel']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoCreateAppRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoCreateAppRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['packageName'] && !(typeof data['packageName'] === 'string' || data['packageName'] instanceof String)) {
            throw new Error("Expected the field `packageName` to be a primitive type in the JSON string but got " + data['packageName']);
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['developer'] && !(typeof data['developer'] === 'string' || data['developer'] instanceof String)) {
            throw new Error("Expected the field `developer` to be a primitive type in the JSON string but got " + data['developer']);
        }
        // ensure the json data is a string
        if (data['profileImage'] && !(typeof data['profileImage'] === 'string' || data['profileImage'] instanceof String)) {
            throw new Error("Expected the field `profileImage` to be a primitive type in the JSON string but got " + data['profileImage']);
        }
        // ensure the json data is a string
        if (data['appUrl'] && !(typeof data['appUrl'] === 'string' || data['appUrl'] instanceof String)) {
            throw new Error("Expected the field `appUrl` to be a primitive type in the JSON string but got " + data['appUrl']);
        }

        return true;
    }


}



/**
 * @member {Number} category
 */
CampaignControllerDtoCreateAppRequest.prototype['category'] = undefined;

/**
 * @member {String} packageName
 */
CampaignControllerDtoCreateAppRequest.prototype['packageName'] = undefined;

/**
 * @member {String} title
 */
CampaignControllerDtoCreateAppRequest.prototype['title'] = undefined;

/**
 * @member {String} developer
 */
CampaignControllerDtoCreateAppRequest.prototype['developer'] = undefined;

/**
 * @member {String} profileImage
 */
CampaignControllerDtoCreateAppRequest.prototype['profileImage'] = undefined;

/**
 * @member {String} appUrl
 */
CampaignControllerDtoCreateAppRequest.prototype['appUrl'] = undefined;

/**
 * @member {module:model/DistributionChannel} distributionChannel
 */
CampaignControllerDtoCreateAppRequest.prototype['distributionChannel'] = undefined;






export default CampaignControllerDtoCreateAppRequest;

